import * as React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router } from 'react-router-dom';

import { queryClient } from 'src/lib/react-query';
import { AuthProvider } from 'src/providers/AuthProvider';
import { IntlProvider } from 'src/providers/IntlProvider';
import { SidePanelContextProvider } from 'src/registry/providers/SidePanelProvider';
import { Toaster } from 'src/registry/ui/Toaster';
import { TooltipProvider } from 'src/registry/ui/Tooltip';

type AppProviderProps = {
    children: React.ReactNode;
};
// AppProvider: ErrorBoundary for error handling.
// HelmetProvider for swapping the Head element (title, meta, etc...)
// IntlProvider is a wrapper for i18n messages
// QueryClient and Router are self explanatory
export const AppProvider = ({ children }: AppProviderProps) => (
    <HelmetProvider>
        <QueryClientProvider client={queryClient}>
            <AuthProvider>
                <IntlProvider>
                    <TooltipProvider>
                        <SidePanelContextProvider>
                            <Router>{children}</Router>
                            <Toaster />
                        </SidePanelContextProvider>
                    </TooltipProvider>
                </IntlProvider>
            </AuthProvider>
            {process.env.NODE_ENV === 'development' && <Debug />}
        </QueryClientProvider>
    </HelmetProvider>
);


const Debug = () => {
    return (
        <div className="fixed top-0 right-0 z-50 flex size-8 items-center justify-center bg-black/50 font-mono text-xs text-white">
            <p className="hidden 2xl:block">2xl</p>
            <p className="hidden xl:block 2xl:hidden">xl</p>
            <p className="hidden lg:block xl:hidden">lg</p>
            <p className="hidden md:block lg:hidden">md</p>
            <p className="hidden sm:block md:hidden">sm</p>
            <p className="xs:block hidden sm:hidden">xs</p>
            <p className="xs:hidden block">2xs</p>
        </div>
    );
};
